var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"playlist-song-search-link",on:{"click":function($event){return _vm.openPlaylist(_vm.playlist)}}},[_c('div',{staticClass:"droppable-playlist",attrs:{"id":_vm.uid}},[_vm._v(_vm._s(_vm._f("momentDate")(_vm.playlist.creation_date))+" - "+_vm._s(_vm.playlist.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }